import { createModalContext } from "shared/components/vero-modal";

export const {
  Context: RemoveApplicantModalContext,
  Provider: RemoveApplicantModalProvider,
  useModalContext: useRemoveApplicantModal,
} = createModalContext();
